import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const MedicalPDFViewer = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate(-1); // Go back to previous page
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: '#1e1e1e',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: 2,
          backgroundColor: '#2d2d2d',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        }}
      >
        <Typography variant="h6" sx={{ color: 'white', fontWeight: 600 }}>
          Medical Laboratory User Manual
        </Typography>
        <IconButton
          onClick={handleClose}
          sx={{
            color: 'white',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      {/* PDF Viewer - Using iframe with disabled download */}
      <Box sx={{ flex: 1, overflow: 'hidden' }}>
        <iframe
          src="/main/User Manual-Medical form.pdf#toolbar=0&navpanes=0&scrollbar=1"
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
          }}
          title="Medical User Manual"
          onContextMenu={(e) => e.preventDefault()} // Disable right-click
        />
      </Box>

      {/* Overlay to prevent downloads - covers the PDF iframe */}
      <style>
        {`
          iframe {
            pointer-events: auto;
          }
          /* Disable print dialog */
          @media print {
            body {
              display: none;
            }
          }
        `}
      </style>
    </Box>
  );
};

export default MedicalPDFViewer;
